import axios from "axios";
import {weatherType} from "../types/WeatherType";

export class WeatherService {
  static async find(city: string) {
    const response = await axios.get(`https://www.prevision-meteo.ch/services/json/${city}`);

    // L'API répond 200 avec {errors: [...]} si la ville est inconnue
    if (response.data?.current_condition === undefined) {
      throw new Error(response.data?.errors?.[0]?.text ?? 'Invalid weather response');
    }

    return response.data as weatherType;
  }
}
